export default {"src":"/_next/static/media/sunrise.54df953e.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};